import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Button,
  Box,
  Typography,
} from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import CloseIcon from "@mui/icons-material/Close";

function SpierDialog({ dataHint }) {
  const [open, setOpen] = useState(false);

  // Vervang underscores met spaties
  const formattedName = dataHint.replace(/_/g, " ");

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <IconButton onClick={handleOpen} size="small" color="primary">
        <HelpOutlineIcon fontSize="inherit" />
      </IconButton>
      <Dialog open={open} onClose={handleClose} fullWidth>
        <DialogTitle>
          <Typography variant="h6">{formattedName}</Typography>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Box display="flex" justifyContent="center">
            <img
              src={`/spierenimages/${dataHint}.png`}
              alt={`Afbeelding van ${formattedName}`}
              style={{ maxWidth: "100%", height: "auto" }}
            />
          </Box>
        </DialogContent>
        <Button onClick={handleClose} color="primary">
          Sluiten
        </Button>
      </Dialog>
    </>
  );
}

export default SpierDialog;
